import {
  HttpNotFoundError,
  IBlocSyncInteractor,
  SyncInteractor
} from "@kernel/frontend-react-app";

export interface HttpNotFoundErrorPorps {
  err: HttpNotFoundError;
}

export class HttpNotFoundErrorInteractor
  extends SyncInteractor<HttpNotFoundErrorPorps, string>
  implements IBlocSyncInteractor<HttpNotFoundErrorPorps, string>
{
  public execute({ err }: HttpNotFoundErrorPorps): string {
    return `[404] ${err.message}`;
  }

  public static create() {
    return new HttpNotFoundErrorInteractor();
  }
}
